<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="data-list-container" id="data-list-list-view">

    <data-view-sidebar :data="sidebarData" :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar"/>

    <vs-table :data="products" :max-items="itemsPerPage" multiple pagination ref="table" search v-model="selected">

      <div class="flex flex-wrap-reverse items-center flex-grow justify-between" slot="header">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown class="dd-actions cursor-pointer mr-4 mb-4" vs-trigger-click>

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon class="mr-2" icon="TrashIcon" svgClasses="h-4 w-4"/>
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon class="mr-2" icon="ArchiveIcon" svgClasses="h-4 w-4"/>
                  <span>Archive</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon class="mr-2" icon="FileIcon" svgClasses="h-4 w-4"/>
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon class="mr-2" icon="SaveIcon" svgClasses="h-4 w-4"/>
                  <span>Another Action</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- ADD NEW -->
          <div @click="addNewData" class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
            <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown class="cursor-pointer mb-4 mr-4 items-per-page-handler" vs-trigger-click>
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ products.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : products.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="category">Category</vs-th>
        <vs-th sort-key="popularity">Popularity</vs-th>
        <vs-th sort-key="order_status">Order Status</vs-th>
        <vs-th sort-key="price">Price</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.name }}</p>
          </vs-td>

          <vs-td>
            <p class="product-category">{{ tr.category | title }}</p>
          </vs-td>

          <vs-td>
            <vs-progress :color="getPopularityColor(Number(tr.popularity))" :percent="Number(tr.popularity)" class="shadow-md"/>
          </vs-td>

          <vs-td>
            <vs-chip :color="getOrderStatusColor(tr.order_status)" class="product-order-status">{{ tr.order_status | title }}</vs-chip>
          </vs-td>

          <vs-td>
            <p class="product-price">${{ tr.price }}</p>
          </vs-td>

          <vs-td class="whitespace-no-wrap">
            <feather-icon @click.stop="editData(tr)" icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"/>
            <feather-icon @click.stop="deleteData(tr.id)" class="ml-2" icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"/>
          </vs-td>

        </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
  import DataViewSidebar from '../DataViewSidebar.vue'
  import moduleDataList from '@/store/data-list/moduleDataList.js'

  export default {
    components: {
      DataViewSidebar
    },
    data ()
    {
      return {
        selected:     [],
        // products: [],
        itemsPerPage: 4,
        isMounted:    false,

        // Data Sidebar
        addNewDataSidebar: false,
        sidebarData:       {}
      }
    },
    computed:   {
      currentPage ()
      {
        if (this.isMounted)
        {
          return this.$refs.table.currentx
        }
        return 0
      },
      products ()
      {
        return this.$store.state.dataList.products
      },
      queriedItems ()
      {
        return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
      }
    },
    methods:    {
      addNewData ()
      {
        this.sidebarData = {}
        this.toggleDataSidebar(true)
      },
      deleteData (id)
      {
        this.$store.dispatch('dataList/removeItem', id).catch(err => { console.error(err) })
      },
      editData (data)
      {
        // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
        this.sidebarData = data
        this.toggleDataSidebar(true)
      },
      getOrderStatusColor (status)
      {
        if (status === 'on_hold') return 'warning'
        if (status === 'delivered') return 'success'
        if (status === 'canceled') return 'danger'
        return 'primary'
      },
      getPopularityColor (num)
      {
        if (num > 90) return 'success'
        if (num > 70) return 'primary'
        if (num >= 50) return 'warning'
        if (num < 50) return 'danger'
        return 'primary'
      },
      toggleDataSidebar (val = false)
      {
        this.addNewDataSidebar = val
      }
    },
    created ()
    {
      if (!moduleDataList.isRegistered)
      {
        this.$store.registerModule('dataList', moduleDataList)
        moduleDataList.isRegistered = true
      }
      this.$store.dispatch('dataList/fetchDataListItems')
    },
    mounted ()
    {
      this.isMounted = true
    }
  }
</script>

<style lang="scss">
  #data-list-list-view {
    .vs-con-table {

      /*
        Below media-queries is fix for responsiveness of action buttons
        Note: If you change action buttons or layout of this page, Please remove below style
      */
      @media (max-width: 689px) {
        .vs-table--search {
          margin-left: 0;
          max-width: unset;
          width: 100%;

          .vs-table--search-input {
            width: 100%;
          }
        }
      }

      @media (max-width: 461px) {
        .items-per-page-handler {
          display: none;
        }
      }

      @media (max-width: 341px) {
        .data-list-btn-container {
          width: 100%;

          .dd-actions,
          .btn-add-new {
            width: 100%;
            margin-right: 0 !important;
          }
        }
      }

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search {
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            & + i {
              left: 1rem;
            }

            &:focus + i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr {
          box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

          td {
            padding: 20px;

            &:first-child {
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }

            &:last-child {
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }

          td.td-check {
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead {
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text {
            text-transform: uppercase;
            font-weight: 600;
          }
        }

        th.td-check {
          padding: 0 15px !important;
        }

        tr {
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
